export default __webpack_public_path__ + "media/images/filter-4bfa574445f1f3ccf9d4ed45a8c517f7.png";